export default "__VITE_PUBLIC_ASSET__78305c3a__"